<div class="modal-header" id="address-select-info-modal-title">
    <h3 class="modal-title">{{ 'TIMESHEET_ADDRESS_HELP_INFO_LABEL' | translate }}</h3>
</div>

<div class="modal-body" id="modal-body">
    <div *ngIf="allowToDelete">
        <span>{{ closeButtonTextBefore }}</span>
        <fa-icon [icon]="faTrashAlt"></fa-icon>
        <span>{{ closeButtonTextAfter }}</span>
    </div>

    <br />

    <div *ngIf="allowToHide">
        <span>{{ hideButtonTextBefore }}</span>
        <fa-icon [icon]="faEyeSlash"></fa-icon>
        <span>{{ hideButtonTextAfter }}</span>
    </div>
</div>

<div class="modal-footer">
    <button class="btn btn-primary" type="button" (click)="close()">{{ 'MODAL_OK' | translate }}</button>
</div>
